import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSGenossenschaftDaten from './TSGenossenschaftDaten';

export default class TSGenossenschaft extends TSAbstractEntity implements TSSerializable<TSGenossenschaft> {

    private _genossenschaftDatenFS: TSGenossenschaftDaten;

    private _genossenschaftDatenGS: TSGenossenschaftDaten | undefined;

    public get genossenschaftDatenFS(): TSGenossenschaftDaten {
        return this._genossenschaftDatenFS;
    }

    public set genossenschaftDatenFS(value: TSGenossenschaftDaten) {
        this._genossenschaftDatenFS = value;
    }

    public get genossenschaftDatenGS(): TSGenossenschaftDaten|undefined {
        return this._genossenschaftDatenGS;
    }

    public set genossenschaftDatenGS(value: TSGenossenschaftDaten|undefined) {
        this._genossenschaftDatenGS = value;
    }

    deserialize(restObject: any): TSGenossenschaft {
        super.deserialize(restObject);

        this.genossenschaftDatenFS = this.deserializeOrCreate(restObject.genossenschaftDatenFS, new TSGenossenschaftDaten());
        this.genossenschaftDatenGS = this.deserializeOrNull(restObject.genossenschaftDatenGS, new TSGenossenschaftDaten());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.genossenschaftDatenFS = this.serializeOrInit(this.genossenschaftDatenFS, restObject.genossenschaftDatenFS);
        restObject.genossenschaftDatenGS = this.serializeOrInit(this.genossenschaftDatenGS, restObject.genossenschaftDatenGS);

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGenossenschaft.ts